exports = module.exports = require("../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".vp-top-right{position:absolute;padding:.1rem;top:0;right:0;text-align:right}.vp-top-left{position:absolute;padding:.1rem;top:0;left:0;text-align:left}", ""]);

